<h2 mat-dialog-title>
  <mat-icon class="outlined">send_to_mobile</mat-icon>
  Send en SMS med invitation til OK-appen
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-6">
      <div class="fit-content">
        <ok-feedback-info>
          <div>
            <b>Bemærk</b>
            <br />
            <ul>
              <li>Invitationen sendes i form af en sms. Sms'en indeholder et link til OK-appen</li>
              <li>SMS sendes til brugerens oplyste mobil nummer: {{ chargingUser.phoneNumber }}</li>
              <li>Linket udløber 48 timer efter at sms'en er afsendt</li>
            </ul>
          </div>
        </ok-feedback-info>
      </div>
      <div class="flex table-header margin--top-l">
        <h4>Invitations historik</h4>
        <button
          type="submit"
          class="send-button"
          mat-flat-button
          color="primary"
          (click)="gotoSend()"
          [disabled]="this.chargingUser.deviceId !== null || this.chargingUser.mokUserNumber !== null">
          Send ny invitation
        </button>
      </div>
    </div>

    <adm-loading-spinner [loading$]="loading$"></adm-loading-spinner>

    <table
      #appInvitationList
      mat-table
      [dataSource]="data$"
      [class.loading-blur]="loading$ | async"
      [class.loading-blur--done]="(loading$ | async) === false"
      class="invitation-table"
      matSort
      (matSortChange)="sortData($event)">
      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber" class="col">Mobilnummer</th>
        <td mat-cell *matCellDef="let invitation" class="row">+{{ invitation.phoneCountryCode }} {{ invitation.phoneNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="organizationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="organizationName" class="col">Organisation</th>
        <td mat-cell *matCellDef="let invitation" class="row">
          {{ invitation.organizationName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="appInvitationStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Status</th>
        <td mat-cell *matCellDef="let invitation" class="row">
          {{ invitation.appInvitationStatus | translateAppInvitationStatusEnum }}
        </td>
      </ng-container>
      <ng-container matColumnDef="deepLinkCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Deeplink oprettet</th>
        <td
          mat-cell
          *matCellDef="let invitation"
          class="row"
          title="{{ invitation.deepLinkCreated | date: 'dd.MM.yyyy HH:mm:ss' }}"
          (click)="consoleLogDeepLink(invitation)">
          {{ invitation.deepLinkCreated | date: 'short' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="smsSent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="col text-center">Sms sendt</th>
        <td mat-cell *matCellDef="let invitation" class="row text-center">
          @if (invitation.appInvitationStatus === statuses.Queued) {
            <mat-icon [matTooltip]="invitation.executionDate | date: 'dd.MM.yyyy HH:mm:ss'">schedule</mat-icon>
          } @else {
            {{ invitation.smsSent | date: 'short' }}
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="col align-right"></th>
        <td mat-cell *matCellDef="let invitation" class="row align-right">
          <button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="Handlinger" class="actions-button">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #contextMenu="matMenu">
            @if (invitation.appInvitationStatus !== statuses.Queued) {
              <button
                mat-menu-item
                (click)="reSend(invitation)"
                [disabled]="this.chargingUser.mokUserNumber !== null || this.chargingUser.deviceId !== null">
                <mat-icon class="outlined">send_to_mobile</mat-icon>
                <span>Genudsend invitation</span>
              </button>
            }
            @if (invitation.appInvitationStatus === statuses.Queued) {
              <button
                mat-menu-item
                [matTooltip]="'Send nu'"
                (click)="SendQueuedInvitationNow(invitation)"
                [disabled]="this.chargingUser.mokUserNumber !== null || this.chargingUser.deviceId !== null">
                <mat-icon class="outlined">send_to_mobile</mat-icon>
                <span>Send nu</span>
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let rowData; columns: displayColumns" [class.highlight]="rowData.highlight | async"></tr>
    </table>

    <mat-paginator
      #paginator
      [style.visibility]="appInvitationsCount ? 'visible' : 'hidden'"
      [pageIndex]="currentPage"
      [pageSize]="pagingOptions.pageSize"
      [length]="appInvitationsCount"
      [pageSizeOptions]="pagingOptions.pageSizeOptions"
      (page)="onPageChanged($event)"
      color="accent"
      [disabled]="(loading$ | async) === true" />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (chargingUser) {
    <div class="unit-identifier">
      <span>Bruger ID:</span>
      {{ chargingUser.identifier }}
    </div>
  }

  <button type="button" mat-button color="primary" (click)="close()">Luk</button>
</mat-dialog-actions>
